import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { InvitedMessage } from '@/components/pages/Membership/Index/InvitedMessage';
import { InvitationLinkContainer } from '@/components/pages/Membership/Index/InvitationLink';
import { MembershipListContainer } from '@/components/pages/Membership/Index/MembershipList';
import { pages } from '@/settings/pages';
import { Loading } from '@/components/utils/Loading';
import { useCheckReAuthenticationExpiration } from '@/hooks/useCheckReAuthenticationExpiration';

export const MembershipPage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.membership.index.title');
  const [isLoading, setIsLoading] = useState(true);

  const checkReAuthenticationExpiration = useCheckReAuthenticationExpiration(
    setIsLoading,
    pages.membership.index,
  );

  useEffect(() => {
    checkReAuthenticationExpiration();
  }, [checkReAuthenticationExpiration]);

  const location = useLocation();
  const invitedEmail = location.state?.email as string | undefined;
  const [invitedMessageVisible, setInvitedMessageVisible] = useState<boolean>(
    !!invitedEmail,
  );

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      hasHeaderDivider={true}
      breadcrumbItems={[{ label: title }]}
      containerType="wide"
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {invitedMessageVisible && invitedEmail && (
            <InvitedMessage
              email={invitedEmail}
              setVisible={setInvitedMessageVisible}
            />
          )}

          {!invitedMessageVisible && <InvitationLinkContainer />}

          <MembershipListContainer />
        </>
      )}
    </PageRootWrapper>
  );
};
